// Small display component for a cent amount. Optionally color-codes by sign:
// positive in green, negative in red, zero in slate. Useful for transaction
// rows and balance summaries.

import { formatMoney } from "../utils/format";

interface MoneyProps {
  cents: number;
  currency?: string;
  signed?: boolean;
  colored?: boolean;
  className?: string;
}

export default function Money({
  cents,
  currency = "EUR",
  signed = false,
  colored = false,
  className,
}: MoneyProps) {
  const formatted = formatMoney(cents, currency);
  // Force a leading '+' for positive signed amounts. Intl already prints '-'
  // for negative amounts so we don't need to inject it.
  const display = signed && cents > 0 ? `+${formatted}` : formatted;

  let colorClass = "";
  if (colored) {
    if (cents > 0) colorClass = "text-green-600";
    else if (cents < 0) colorClass = "text-red-600";
    else colorClass = "text-slate-600";
  }

  return (
    <span className={`${colorClass} ${className ?? ""}`.trim()}>{display}</span>
  );
}
